import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as formReducer, FormStateMap } from 'redux-form';
//@ts-ignore
import session from './session';
//@ts-ignore
import calendar from './calendar';
//@ts-ignore
import app from './app';
import SessionState from '../models/SessionState';
import CalendarState from '../models/calendar/CalendarState';
import authReducer, { IAuthState } from './Auth';

// TODO: add typing to the other states.
export interface IRootState {
  router: any;
  form: FormStateMap;
  session: SessionState;
  calendar: CalendarState;
  app: any;
  auth: IAuthState;
}

const rootReducer = combineReducers<IRootState>({
  router,
  form: formReducer,
  session,
  calendar,
  app,
  auth: authReducer,
});

export default rootReducer;
